const OrderDemo= () =>import('@/components/order/OrderDemo')
const PaySuccess= () =>import('@/components/order/PaySuccess')
// const BuyGroupOrderList= () =>import('@/components/buygroup/BuyGroupOrderList')
// const BuyGroupOrder= () =>import('@/components/buygroup/BuyGroupOrder')
// const PaySuccess= () =>import('@/components/buygroup/PaySuccess')
// const BuyGroupOrderShare= () =>import('@/components/buygroup/BuyGroupOrderShare')
const LoginBottom= () =>import('@/components/base/LoginBottom')
export default[
    {
        path: '/order/demo',
        component: OrderDemo,
        meta: {title: '订单例子'}
    },
    {
        path: '/order/pay_success',
        component: PaySuccess,
        meta: {title: '支付确认'}
    },

]




// WEBPACK FOOTER //
// ./src/router/orderRouter.js